export default __webpack_public_path__ + "static/media/prize.min.1bb2a3f3.png";